import learnLangOrderData from 'src/config/learnLangOrder.json';
import {
  DEFAULT_FLOW_ID,
  FLOW_ID_WITHOUT_L2,
  LOCALE
} from 'src/dataLayer/env';
import { getValidatedQueryStringFromParams } from 'src/dataLayer/localData/queryParams';
import { isFlowAvailable } from 'src/viewLayer/components/Flow/flowHelpers';
import { isInvalidLearnLang } from './validateLearnLang';
import { PathParams } from 'src/types/pathHelpers';

const DEFAULT_LOCALE = 'en_GB';
const DEFAULT_ENVIRONMENT = 'product-preview';

const availableLocales = Object.keys(learnLangOrderData);

const validEnvironmentRegExp = /product-preview.*/;

const buildRedirectionPath = ({
  locale,
  environment,
  learnLang,
  flowId,
  nodeNumber,
  validQueryParams
}: PathParams) : string => {
  const pathQueryParams = validQueryParams.toString() ? `?${validQueryParams.toString()}` : '';
  return (
    `/${locale}/${environment}/${learnLang}/${flowId}/node/${nodeNumber}${pathQueryParams}`
  );
};

export const buildValidFlowPath = ({
  locale = LOCALE,
  environment,
  learnLang,
  flowId,
  nodeNumber,
  queryParams
} : PathParams) : string => {
  const currentLocale = availableLocales.includes(locale) ? locale : DEFAULT_LOCALE;
  const currentEnvironment = validEnvironmentRegExp.test(environment) ? environment : DEFAULT_ENVIRONMENT;
  let currentFlowId = isFlowAvailable(flowId) ? flowId : DEFAULT_FLOW_ID;
  const currentNodeNumber = nodeNumber || 0;

  if (currentLocale && currentEnvironment && !learnLang) {
    currentFlowId = FLOW_ID_WITHOUT_L2;
  }
  const typedLearnLangOrderData: {[key: string]: string[]} = learnLangOrderData;

  const currentLearnLang = isInvalidLearnLang(learnLang)
    ? typedLearnLangOrderData[currentLocale][0]
    : learnLang;
  const validQueryParams = new URLSearchParams(
    getValidatedQueryStringFromParams(queryParams, currentLearnLang)
  );
  return buildRedirectionPath({
    locale: currentLocale,
    environment: currentEnvironment,
    learnLang: currentLearnLang,
    flowId: currentFlowId,
    nodeNumber: currentFlowId === FLOW_ID_WITHOUT_L2 ? 0 : currentNodeNumber,
    validQueryParams
  });
};
